// extracted by mini-css-extract-plugin
export var container = "_97-0";